export default __webpack_public_path__ + "static/media/1921.d9809376.png";